import Lenis from 'lenis';
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
import '../mega-menu.js';
import '../counter.js';
import '../parallax.js';
import '../realisations-slider.js';
import '../realisations-hero.js';
import '../text-switcher.js';
import '../faq.js';
import '../typing-fade.js';
import '../scroll-image.js';

const lenis = new Lenis({
  duration: 1.0,
  easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  smoothWheel: true,
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);
